import Input from "../../Control/Input";
import React, { useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { Wrapper } from "../../Control/Flexbox";
import RefreshIcon from "@material-ui/icons/Refresh";
import { Select, InputLabel, MenuItem, FormControl } from "@material-ui/core";
import { ExpandLess, ExpandMore, Remove, Add } from "@material-ui/icons";
import { DatePicker } from "@material-ui/pickers";
const MaterialPerformance = (props) => {
  const { ppapData } = props;
  const [render, setRender] = useState(false);
  const [isSpecs, setIsSpecs] = useState([]);
  function handleSpec(e, index) {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    ppapData.mat_per[index][e.target.name] = value;
  }

  function append(where, data) {
    ppapData[where].push(data);
    setRender((prev) => !prev);
  }

  function remove(where, index) {
    if (window.confirm("Are you sure you want to delete Dimension?")) {
      ppapData[where].splice(index, 1);
      setRender((prev) => !prev);
    }
  }

  const hideSpecs = (index) => {
    setIsSpecs((prev) => [...prev, index]);
  };

  const openSpecs = (index) => {
    const values = [...isSpecs];
    const idx = values.indexOf(index);
    values.splice(idx, 1);
    setIsSpecs(values);
  };

  return (
    <div className="specs-container" style={{ marginBottom: "3rem" }}>
      <Wrapper>
        <DatePicker
          inputVariant="filled"
          name="mat_date"
          style={{ paddingLeft: "0.6rem", marginTop: "0rem" }}
          label="Date"
          value={ppapData?.mat_date || null}
          onChange={(date) => {
            ppapData.mat_date = date;
            setRender((prev) => !prev);
          }}
          format="dd/MM/yyyy"
          className="date-field"
        />
        <DatePicker
          inputVariant="filled"
          name="mat_approval_date"
          style={{ paddingLeft: "0.6rem", marginTop: "0rem" }}
          label="Approval Date"
          value={ppapData?.mat_approval_date || null}
          onChange={(date) => {
            ppapData.mat_approval_date = date;
            setRender((prev) => !prev);
          }}
          format="dd/MM/yyyy"
          className="date-field"
        />
        <Input
          type="text"
          name="mat_sign"
          label="Signature"
          onChange={(e) => {
            ppapData.mat_sign = e.target.value;
          }}
          defaultValue={ppapData.mat_sign}
        />
      </Wrapper>
      <div>
        <Wrapper
          justify="space-between"
          style={{ borderBottom: "1px solid #c80202" }}
        >
          <p className="card-btn-para" style={{ color: "#c80202" }}>
            • ADD{" "}
            <span style={{ fontWeight: 400, color: "black" }}>
              MATERIAL PERFORMANCE
            </span>
          </p>
          <Wrapper>
            <Wrapper
              style={{
                height: "45px",
                width: "50px",
                backgroundColor: "#c80202",
                color: "white",
                cursor: "pointer",
              }}
              onClick={() => {
                append("mat_per", {
                  s_no: ppapData.mat_per.length + 1,
                });
              }}
              justify="center"
            >
              <Add />
            </Wrapper>
            <Wrapper
              style={{
                height: "45px",
                width: "50px",
                backgroundColor: "#151a1d",
                color: "white",
                cursor: "pointer",
              }}
              justify="center"
              onClick={() => {
                ppapData?.mat_per?.sort(
                  (a, b) => Number(a.s_no) - Number(b.s_no)
                );
                setRender((prev) => !prev);
              }}
            >
              <RefreshIcon />
            </Wrapper>
          </Wrapper>
        </Wrapper>
      </div>

      {ppapData.mat_per.map((spec, index) => (
        <div
          key={uuidv4()}
          style={{
            marginBottom: "0.3rem",
            marginTop: "0.6rem",
            padding: "0rem",
            border: "1px solid #f0f2f0",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              background: "#fafafa",
              alignItems: "center",
            }}
            className="spec-header"
          >
            <Wrapper>
              <Input
                type="Number"
                name="s_no"
                onBlur={(e) => handleSpec(e, index)}
                defaultValue={spec.s_no}
                style={{ width: "80px" }}
              />
              <Wrapper
                justify="center"
                style={{
                  marginLeft: "0.4rem",
                  fontSize: "0.9rem",
                  textTransform: "uppercase",
                }}
              >
                {spec.dimension}
              </Wrapper>
            </Wrapper>
            <Wrapper>
              {isSpecs.includes(index) ? (
                <Wrapper
                  style={{
                    height: "45px",
                    width: "50px",
                    backgroundColor: "#3f51b5",
                    cursor: "pointer",
                    color: "white",
                  }}
                  justify="center"
                  onClick={() => openSpecs(index)}
                >
                  <ExpandLess />
                </Wrapper>
              ) : (
                <Wrapper
                  style={{
                    height: "45px",
                    width: "50px",
                    backgroundColor: "#3f51b5",
                    cursor: "pointer",
                    color: "white",
                  }}
                  justify="center"
                  onClick={() => hideSpecs(index)}
                >
                  <ExpandMore />
                </Wrapper>
              )}
              <Wrapper
                style={{
                  height: "45px",
                  width: "50px",
                  backgroundColor: "#151a1d",
                  color: "white",
                  cursor: "pointer",
                }}
                justify="center"
                onClick={() => remove("mat_per", index)}
              >
                <Remove />
              </Wrapper>
            </Wrapper>
          </div>
          {isSpecs.includes(index) && (
            <div className="specs-field">
              <Wrapper>
                <Input
                  type="text"
                  name="mat_spec_no"
                  placeholder="Material Spec. No."
                  style={{ width: "300px" }}
                  onBlur={(e) => handleSpec(e, index)}
                  defaultValue={spec.mat_spec_no}
                />
                <Input
                  type="text"
                  name="mat_certificate"
                  placeholder="Certificate"
                  style={{ width: "300px" }}
                  onBlur={(e) => handleSpec(e, index)}
                  defaultValue={spec.mat_certificate}
                />

                <FormControl
                  style={{
                    width: "143px",
                    marginRight: "0.5rem",
                    marginTop: "0rem",
                    marginLeft: "0.6rem",
                  }}
                  variant="filled"
                  className="select-field"
                >
                  <InputLabel>Status</InputLabel>
                  <Select
                    name="mat_status"
                    defaultValue={spec.mat_status}
                    onChange={(e) => handleSpec(e, index)}
                    className="spec-select-character"
                  >
                    <MenuItem value="">None</MenuItem>
                    <MenuItem value="OK">OK</MenuItem>
                    <MenuItem value="NOT OKAY">NOT OKAY</MenuItem>
                  </Select>
                </FormControl>
              </Wrapper>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};
export default MaterialPerformance;
